import UsersCardsContainer from "../../../../Components/Applications/Users/UsersCard/UsersCardsContainer";

const UsersCard = () => {
  return <UsersCardsContainer />;
};

export default UsersCard;
